// src/components/Footer.jsx
// The site's footer: appears at the bottom of every page.
// Structure mirrors Module 7's index.html footer.
//
// Updates from Module 7:
// - Colophon line now reflects the React/Express/Tailwind stack.
// - Volume bumped to No. 2 to match Issue 02.

export default function Footer() {
  return (
    <footer className="border-t border-ink mt-20">
      <div className="max-w-wide mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Correspondence column */}
          <div className="md:col-span-5">
            <p className="label-mono mb-4">Correspondence</p>
            <p className="font-display italic text-lede leading-relaxed mb-4">
              Letters to the editor are welcome.
            </p>
            <p className="text-body text-ink-70 leading-relaxed">
              For consulting, collaboration, or simple curiosity, the door is
              open.
            </p>
          </div>

          {/* Direct column: contact links */}
          <div className="md:col-span-3">
            <p className="label-mono mb-4">Direct</p>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:hello@example.com"
                  className="text-body hover:text-oxblood transition-colors"
                >
                  hello@example.com
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-body hover:text-oxblood transition-colors"
                >
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-body hover:text-oxblood transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          {/* Colophon column: production note */}
          <div className="md:col-span-4">
            <p className="label-mono mb-4">Colophon</p>
            <p className="text-small text-ink-70 leading-relaxed">
              Set in Fraunces, Inter, and IBM Plex Mono. Built with React,
              Express, and TailwindCSS. Issue 02, Summer 2026.
            </p>
          </div>
        </div>

        {/* Hairline divider before bottom row */}
        <hr className="hairline mt-12 mb-6" />

        {/* Bottom row: copyright and volume */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <p className="label-mono">© 2026 Sandra Hershey-Zagrans</p>
          <p className="label-mono">Powell, Ohio · Vol. 1, No. 2</p>
        </div>
      </div>
    </footer>
  );
}
